var styleCp = `body.cp-banner-visible{overflow:hidden!important}#iubenda-cs-banner{top:0!important;left:0!important;position:fixed!important;width:100%!important;height:100%!important;z-index:99999999!important;opacity:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.5)}#iubenda-cs-banner.iubenda-cs-visible{opacity:1}#iubenda-cs-banner *{outline:0!important}#ameConsentUI{all:initial;padding:0;margin:0;width:330px;border-radius:10px;box-shadow:0 5px 20px rgba(0,0,0,.5);background:#fff;font-family:"Arial-BoldMT",sans-serif;display:flex;flex-direction:column;transition:width 200ms ease-in-out;border-radius:14px 14px 10px 10px}#ameConsentUI .amecp_main{height:475px;overflow:hidden}#ameConsentUI *{all:unset;padding:0;margin:0}#ameConsentUI .amecp_cookieTitle{color:#313a41;font-size:22px;font-weight:700;font-style:normal;text-align:center;line-height:20px;max-width:280px;margin:0 auto 10px auto}#ameConsentUI .amecp_cookieTextArea{padding:23px 23px 0 23px;flex-grow:1;display:flex;flex-direction:column}#ameConsentUI .amecp_cookieText{opacity:1;color:#50575d;font-family:"ArialMT",sans-serif;font-size:14px;font-weight:400;text-align:center;line-height:22px;overflow:auto;display:block;padding-bottom:20px;flex-shrink:0;height:170px}#ameConsentUI .amecp_cookieText .amecp_cookieTextTrick{height:0;overflow:visible;display:block}#ameConsentUI .amecp_button-rifiuta{color:#404040;font-size:13px;font-weight:700;text-align:center;line-height:32px;border-radius:15px;background-color:#ededed;cursor:pointer;margin-bottom:5px}#ameConsentUI .amecp_cookieBottom{box-shadow:0 2px 60px rgba(0,0,0,.3);padding:11px 23px 15px 23px;display:flex;flex-direction:column}#ameConsentUI .amecp_claim{color:#333;font-size:12px;font-weight:700;text-align:center;line-height:24px;margin-bottom:5px;display:flex;gap:5px;justify-content:center}#ameConsentUI .amecp_logo{width:20px;height:20px;display:block}#ameConsentUI .amecp_cookieBottom button{border-radius:25px;height:46px;border:2px solid #0073ce;background-color:#0073ce;text-align:center;font-size:16px;color:#fff;cursor:pointer;margin:0 -10px 10px -10px;position:relative}#ameConsentUI .amecp_cookieBottom button.amecp_button-customize{color:#0073ce;background:#fff}#ameConsentUI button,#ameConsentUI a{opacity:1;transition:opacity 100ms ease-in-out}#ameConsentUI a{text-decoration:underline;cursor:pointer}#ameConsentUI button span{position:absolute;top:calc(50% - 1px);right:10%;height:2px;background:#fff;width:15px;display:block}#ameConsentUI button span:after{content:'';height:8px;width:8px;border-right:2px solid #fff;border-top:2px solid #fff;position:absolute;right:0;top:-4px;transform:rotate(45deg)}#ameConsentUI button:hover,#ameConsentUI a:hover{opacity:.8}#ameConsentUI .cpStep2Mask{width:100%;height:100dvh;position:fixed;top:0;left:0;z-index:100;display:none;justify-content:center;align-items:center;opacity:0}#ameConsentUI .cpStep2{width:330px;background-color:#fff;display:flex;flex-direction:column;justify-content:space-between;border-radius:14px 14px 10px 10px;overflow:hidden}#ameConsentUI .cpStep2MaskVisible{display:flex}#ameConsentUI .cpStep2MaskVisibleEffect{opacity:1;transition:500ms ease-in-out opacity}#ameConsentUI .cpStep2Top{height:330px;overflow:auto;display:block}#ameConsentUI .cpStep2 .cpStep2Title{font-size:22px;display:block;font-weight:700;margin-bottom:10px}#ameConsentUI .cpStep2 .cpStep2Body{font-size:13px;text-align:center;line-height:1.3em;padding:10px 23px 0 23px;display:block}#ameConsentUI .cpStep2 .cpStep2Body p{display:block;margin-bottom:1em;color:#50575d;font-family:"ArialMT",sans-serif;font-size:14px;line-height:22px}#ameConsentUI .cpStep2 .cpStep2Footer{box-shadow:0 2px 60px rgba(0,0,0,.3);padding:10px 23px 15px 23px;display:flex;flex-direction:column}#ameConsentUI .cpStep2 #cpStep2Back{font-size:14px;line-height:17px;display:flex;text-decoration:none;font-weight:700;align-items:center;gap:5px;color:#50575d;margin:23px 0 0 23px}#ameConsentUI .cpStep2 #cpStep2Back svg{width:16px}#ameConsentUI .cpStep2 button{border-radius:25px;height:46px;border:2px solid #0073ce;background-color:#0073ce;text-align:center;font-size:16px;color:#fff;cursor:pointer;margin:0 -10px 10px -10px;position:relative}@media screen and (min-width:1000px){#ameConsentUI{width:420px}#ameConsentUI .cpStep2{width:420px}}`
 /**
 * @fileoverview CMP (Consent Management Platform) - Gestione consenso cookie e purpose custom.
 * Configurazione Iubenda TCF 2.x con purpose aggiuntivi (SDK Nielsen/Auditel, rilevazione volumetrica).
 * Logica speciale: quando l'utente vergine clicca "Nega tutto" dal banner (senza aprire opzioni),
 * viene forzato rilevazionevolumetrica=true. Negli altri casi si rispettano le scelte dell'utente.
 */
/**
 * Configurazione tracciamento GA4 `cmp_log_v{N}` (campionamento per sessione, per-origin).
 * `version`: numero versione; pilota eventName GA4 (`cmp_log_v` + version) e chiavi sessionStorage.
 * `readyRetries` / `readyRetryDelay`: polling fino a presenza di `gtag('config','G-*'|'GT-*')` nel dataLayer.
 * `origins`: chiave substring di `location.hostname` (match sulla chiave più lunga tra quelle compatibili).
 * `mode`: "all" (sempre, se campionati) | "only_without_consent_cookie" (solo se al load non c'è ancora
 * il cookie `_iub_cs-*` di Iubenda: tipicamente chi deve ancora esprimere preferenze, non “chi ha negato”).
 * Alias deprecato ma ancora accettato: "only_no_consent" (stesso effetto di only_without_consent_cookie).
 * "off" disattiva solo quell'origin.
 * Valori opzionali per chiave: `{ sampleRate?, mode? }`; se omessi si usano `defaultSampleRate` e `defaultMode`.
 */
var CMP_LOG_CONFIG = {
  enabled: true,
  version: 2,
  defaultSampleRate: 10,
  defaultMode: "all",
  readyRetries: 60,
  readyRetryDelay: 500,
  origins: {
    "sorrisi.com": {},
    "focus.it": {},
    "focusjunior.it": {},
    "chimagazine.it": {},
    "interni.it": {}
  }
};

/**
 * Shortcode TCF vendor count (https://www.iubenda.com/en/help/140986).
 * Va in `banner.content`; in `banner.html` usare `%{banner_content}` (help/1205).
 */
/* --- BEGIN DAF-406: normalizzazione volumetrica pre-deploy (MODULO A TERMINE) --- */
/**
 * Normalizzazione retroattiva di `rilevazionevolumetrica` sui consensi espressi
 * PRIMA che esistesse la forzatura di `onConsentRejected` (in produzione dal
 * 24-31 marzo 2026, DAF-377 / DAF-379).
 *
 * Quei cookie portano `rilevazionevolumetrica: false` non perche' l'utente abbia
 * rifiutato la rilevazione, ma perche' ha negato tutto dal banner, dove quella
 * casella non e' mostrata. E' lo stesso caso che oggi `onConsentRejected` gia'
 * tratta come consenso: qui la regola viene applicata retroattivamente.
 *
 * `cutoff`: si normalizzano solo i cookie con `timestamp` precedente.
 * `scadenzaModulo`: oltre questa data il modulo non fa piu' nulla.
 *
 * NESSUN FILTRO SULL'ORIGIN. Il modulo gira su tutti i siti serviti da questo
 * file: la condizione e' il cookie, non il dominio. Un cookie scritto prima del
 * cutoff con `rilevazionevolumetrica: false` ha la stessa origine ovunque, cioe'
 * un banner in cui quella casella non c'era. Fino al 2026-09-22 il modulo era
 * limitato a `sorrisi.com` per misurarne l'effetto su un sito solo; misurato,
 * il filtro e' stato tolto (divario 30,40% -> 15,3%, blocchi della coorte
 * pre-aprile 36,70% -> 0,07%).
 *
 * MODULO A TERMINE. Il cookie Iubenda dura 365 giorni e non viene rinnovato ai
 * caricamenti successivi: un cookie scritto prima del 2026-04-01 non puo'
 * esistere dopo il 2027-04-01. Da rimuovere alla prima delle due condizioni:
 * evento `Volumetrica_Normalizzata` a zero per due settimane, oppure
 * superamento di `scadenzaModulo`. Istruzioni di rimozione in
 * `docs/cmp/CMP_REFERENCE.md`.
 */
var NORMALIZZA_VOLUMETRICA_CONFIG = {
  enabled: true,
  cutoff: "2026-04-01",
  scadenzaModulo: "2027-04-01"
};

/* ATTENZIONE ALL'ORDINE. Tutto cio' che segue deve stare QUI, prima di
   `initRilevazioneVolumetricaFlags`, che e' il punto in cui il modulo viene
   chiamato. Sono `var`: la DICHIARAZIONE viene sollevata, l'ASSEGNAZIONE no.
   Dichiarandole piu' in basso nel file, all'init valevano `undefined`, con due
   effetti entrambi silenziosi:
     - GIORNI_COOKIE_IUBENDA undefined  -> max-age=NaN -> Set-Cookie invalido,
       la normalizzazione non avveniva mai;
     - CHIAVE_MARCATORE_VOLUMETRICA undefined -> il marcatore finiva sotto la
       chiave letterale "undefined".
   Non spostarle di nuovo piu' in basso. */

/** @type {string} - chiave localStorage: contiene la data ORIGINALE di espressione del consenso */
var CHIAVE_MARCATORE_VOLUMETRICA = "_iub_volumetrica_normalizzata";
/** @type {string|null} - esito della normalizzazione, per l'evento GA4 a onReady */
var _esitoNormalizzazioneVolumetrica = null;
/** @type {string} - mese di scrittura del cookie normalizzato (YYYY-MM) */
var _meseCookieNormalizzato = "";
/**
 * Durata con cui Iubenda scrive il cookie di consenso. Serve a ricalcolare il
 * residuo di scadenza: la normalizzazione non deve prolungare la vita del
 * consenso, quindi si riscrive con il tempo che restava, non con 365 giorni nuovi.
 */
var GIORNI_COOKIE_IUBENDA = 365;
/* --- END DAF-406 --- */

var IUB_VENDOR_COUNT_SHORTCODE = "%{total_number_of_ads_vendors}";
/** Fallback se nel DOM resta ancora il literal dello shortcode vendor. */
var IUB_VENDOR_COUNT_FALLBACK = 765;

var brands = [
  {
    key: "sorrisi",
    brand: "Sorrisi"
  },
  {
    key: "focus.it",
    brand: "Focus"
  },
  {
    key: "focus-scuola.it",
    brand: "Focus"
  },
  {
    key: "focusjunior",
    brand: "Focus Junior"
  },
  {
    key: "casabella",
    brand: "Casabella"
  },
  {
    key: "interni",
    brand: "Interni"
  },
  {
    key: "chimagazine.it",
    brand: "Chi"
  },
  {
    key: "mondadoriacademy",
    brand: "MondadoriAcademy"
  },
  {
    key: "ingleseconmontessori-inedicola.it",
    brand: "Mondadori Media"
  }
];

const nodeStyleCp = document.createElement("style");
nodeStyleCp.innerHTML = styleCp;
document.head.appendChild(nodeStyleCp);


var ameCp = {
  siteIdValue: 4333285,
  cookiePolicyIdValue: 83285103,
  cookiePolicyUrl: "https://digital.mondadori.it/docs/media/cookie-policy-mondadori-media-spa.html",
  localConsentDomain: null,
  lang: "it",
  logoDOM: "",
  cpUrl() {
    return (
      "https://www.iubenda.com/privacy-policy/" +
      this.cookiePolicyIdValue +
      "/cookie-policy"
    );
  },
  titolo: "Informativa sull'utilizzo dei cookie del browser",
  tastoAccetta: "Accetta e chiudi",
  tastoOpzioni: "Opzioni cookie",
  tastoRifiuta: "Continua senza accettare",
  claim: "ha a cuore la tua privacy",
  brand: "Mondadori Media",
};

let faviconhost = document.location.host;
for (i = 0; i < brands.length; i++) {
  if (location.hostname.match(brands[i].key)) {
    ameCp.brand = brands[i].brand;
    faviconhost = document.location.host;
    break;
  } else {
    faviconhost = "https://www.gruppomondadori.it/";
    ameCp.brand = "Mondadori Media";
  }
}

ameCp.text = `<p>Noi e ${IUB_VENDOR_COUNT_SHORTCODE} terze parti selezionate utilizziamo cookie o tecnologie simili per finalità tecniche e, con il tuo consenso, anche per altre finalità come specificato nella <a class="iubenda-cs-cookie-policy-lnk" rel="nofollow">cookie policy</a>.</p>
<p>Per quanto riguarda la pubblicit&agrave;, noi e <a class="iubenda-vendor-list-link" rel="nofollow">terze parti selezionate</a>, potremmo <em>utilizzare dati di geolocalizzazione precisi</em> e <em>fare una scansione attiva delle caratteristiche del dispositivo ai fini dell'identificazione</em>, al fine di <em>archiviare e/o accedere a informazioni su un dispositivo</em> e trattare dati personali come i tuoi dati di utilizzo, per le seguenti finalit&agrave;: <em>annunci e contenuti personalizzati, valutazione degli annunci e del contenuto, osservazioni del pubblico e sviluppo di prodotti.</em></p>
<p>Cliccando su "${ameCp.tastoRifiuta}" proseguirai la navigazione senza accettare i cookies di profilazione. Cliccando su “${ameCp.tastoAccetta}, presti il tuo consenso all'utilizzo di tutti i cookie o tecnologie simili. Cliccando su "${ameCp.tastoOpzioni}", puoi esprimere le tue scelte in modo più granulare: a tal proposito, se chiudi tale area senza esprimere alcuna scelta, potrai proseguire la navigazione senza accettare i cookie.</p>
<p>Puoi liberamente prestare, rifiutare o revocare il tuo consenso, in qualsiasi momento, accedendo al pannello <a href="javascript:void(0)" class="iubenda-cs-preferences-link" rel="nofollow">Opzioni cookie</a>.</p>`;

ameCp.cpStep2Back = "Torna indietro";
ameCp.cpStep2Title = "Maggiori informazioni";

ameCp.cpStep2_amecp_button_accetto = "Accetta tutti i cookie";
ameCp.cpStep2_amecp_button_rifiuto = "Procedi con i cookie tecnici";

ameCp.cpStep2Text = `<p>Se clicchi su "${ameCp.cpStep2_amecp_button_accetto}", accetti tutti i cookie, compresi quelli di profilazione e riceverai annunci pubblicitari in linea con le preferenze manifestate nell’ambito della navigazione in rete e ci aiuterai a sviluppare e migliorare i nostri prodotti. Inoltre, il tuo consenso - che potrai sempre revocare - ci aiuterà a reperire le risorse economiche per continuare a fornire gratuitamente contenuti e informazioni di qualità, sostenendo così l'editoria plurale.</p>
 
<p>Se invece confermi di voler proseguire la navigazione solo con i cookie strettamente necessari (cliccando su "${ameCp.cpStep2_amecp_button_rifiuto}") riceverai pubblicit&agrave; generalista di cui non saranno limitati il numero e la ripetizione.</p>

<p>Puoi liberamente modificare le tue scelte, in qualsiasi momento, accedendo al pannello Opzioni cookie, che troverai linkato nel footer del sito.</p>`;




 
function applyAmeCpEnglishPolicyBundle() {
  ameCp.lang = "en";
  ameCp.tastoAccetta = "I Accept";
  ameCp.tastoOpzioni = "Customize";
  ameCp.tastoRifiuta = "Continue without accepting";
  ameCp.titolo = "Policy on Browser Cookie Usage";
  ameCp.text = `<p>Selected ${IUB_VENDOR_COUNT_SHORTCODE} third parties and us use cookies or similar technologies for functional reasons and, with your consent, for other purposes as specified in the <a class="iubenda-cs-cookie-policy-lnk" rel="nofollow">cookie policy</a>.</p>
  <p>With regard to advertising, selected <a class="iubenda-vendor-list-link" rel="nofollow">third parties</a> and us may <em>use precise geolocation data</em> and <em>actively scan device characteristics for identification purposes</em> in order to <em>store and/or access information on a device</em> and process personal data such as your usage data, for the following purposes: <em>personalized ads and content, ads and content evaluation, audience observations, and product development</em>.</p>
  <p>If you click on "Continue without accepting" you will not consent to the profiling cookies and keep browsing. If you click on "Accept and close" you will consent to all cookies or similar technologies. If you click on "Cookie Settings" you will able to configure your choices granularly: in this regard, if you close this area without expressing any choices, you will continue browsing without accepting the cookies.</p>
  <p>You may freely give, deny or withdraw your consent by accessing the <a class="iubenda-cs-preferences-link" rel="nofollow">"Cookie Settings" panel</a> at any moment.</p>`;

  ameCp.claim = "cares about your privacy";
  ameCp.cpStep2Back = "Go back";
  ameCp.cpStep2Title = "Further information";

  ameCp.cpStep2_amecp_button_accetto = "Accept all cookies";
  ameCp.cpStep2_amecp_button_rifiuto = "Proceed with technical cookies";

  ameCp.cpStep2Text = `<p>If you click on "${ameCp.cpStep2_amecp_button_accetto}", you will accept all cookies, including profiling ones, and you will receive advertisements in line with the preferences expressed during web browsing, helping us in developing and improving our products. Furthermore, your consent - which you can always revoke — will help us gather the necessary resources to continue providing free quality content and information, thus supporting plural publishing</p>
  
  <p>If instead you confirm that you want to continue browsing only with strictly necessary cookies (by clicking on "${ameCp.cpStep2_amecp_button_rifiuto}"), you will receive general advertising without any limitation on number and repetion.</p>

  <p>You can always change your choices at any time by accessing the Cookie Options panel, which you will find linked in the footer of the website.</p>`;
}

//Interni Eng
if (
  location.hostname.match("www.internimagazine.com")
) {
  ameCp.localConsentDomain = window.location.host;
  ameCp.cookiePolicyIdValue = 61558113;
  ameCp.cookiePolicyUrl = "https://digital.mondadori.it/docs/media/cookie-policy-mondadori-media-spa-en.html";
  applyAmeCpEnglishPolicyBundle();

}

/* end config siti */

ameCp.logoDOM = `<img src="https://www.google.com/s2/favicons?domain=${faviconhost}&sz=48" width="20" height="20" alt="" class="amecp_logo"/>`;

/*
 * tpl 2 step — non eseguito: ameCp.html viene ridefinito subito dopo (tpl 1 step).
 * Commentato così la stringa non entra nell'AST e non finisce nel bundle minificato.
//tpl 2 step
ameCp.html = `
<div id="ameConsentUI">
  <div class="amecp_main">
    <div class="amecp_cookieTextArea">
        <div class="amecp_cookieTitle">${ameCp.titolo}</div>
        <button role="button" class="amecp_button-rifiuta" id="toStep2">${ameCp.tastoRifiuta}</button>
        <div class="amecp_cookieText">
          <div class="amecp_cookieTextTrick">
          ${ameCp.text}
          </div>
        </div>
    </div>
    <div class="amecp_cookieBottom">
        <div class="amecp_claim"> ${ameCp.logoDOM}<span>${ameCp.brand} ${ameCp.claim}</span></div>
        <button role="button" class="amecp_button-accetto iubenda-cs-accept-btn" autofocus>${ameCp.tastoAccetta}<span></span></button>
        <button role="button" class="amecp_button-customize iubenda-cs-preferences-link">${ameCp.tastoOpzioni}</button>
        <span class="iubenda-cs-close-btn" style="display: none;"></span>
    </div>
   </div>

   <div class="cpStep2Mask" id="cpStep2Mask">
   <div class="cpStep2">
   <div class="cpStep2Top">
   <div class="cpStep2Header">
     <a id="cpStep2Back">
     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>Artboard-35</title><g id="Left-2" data-name="Left"><polygon points="24 12.001 2.914 12.001 8.208 6.706 7.501 5.999 1 12.501 7.5 19.001 8.207 18.294 2.914 13.001 24 13.001 24 12.001" style="fill:#000"/></g></svg>
     ${ameCp.cpStep2Back}
     </a>
   </div>
   <div class="cpStep2Body">
     <div class="cpStep2Title">${ameCp.cpStep2Title}</div>
     <div class="cpStep2Text">
    ${ameCp.cpStep2Text}
     </div>
   </div>
   </div>
   <div class="cpStep2Footer">
     <button role="button" class="amecp_button-accetto iubenda-cs-accept-btn">${ameCp.cpStep2_amecp_button_accetto}<span></span></button>
     <button role="button" class="iubenda-cs-reject-btn">${ameCp.cpStep2_amecp_button_rifiuto}</button>
   </div>
   </div>
 </div>
</div>
`;
*/

//tpl 1 step
ameCp.html = `
<div id="ameConsentUI">
  <div class="amecp_main">
    <div class="amecp_cookieTextArea">
        <div class="amecp_cookieTitle">${ameCp.titolo}</div>
        <button role="button" class="amecp_button-rifiuta iubenda-cs-reject-btn">${ameCp.tastoRifiuta}</button>
        <div class="amecp_cookieText">
          <div class="amecp_cookieTextTrick">
          %{banner_content}
          </div>
        </div>
    </div>
    <div class="amecp_cookieBottom">
        <div class="amecp_claim"> ${ameCp.logoDOM}<span>${ameCp.brand} ${ameCp.claim}</span></div>
        <button role="button" class="amecp_button-accetto iubenda-cs-accept-btn" autofocus>${ameCp.tastoAccetta}<span></span></button>
        <button role="button" class="amecp_button-customize iubenda-cs-preferences-link">${ameCp.tastoOpzioni}</button>
        <span class="iubenda-cs-close-btn" style="display: none;"></span>
    </div>
   </div>
</div>
`;

function yieldToMainNC() {
  if ("scheduler" in window && "yield" in scheduler) {
    return scheduler.yield();
  }

  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}

function loadMDAntiOverlap(cb, onErr) {
  if (window.MDAntiOverlap) return cb(window.MDAntiOverlap);
  const s = document.createElement("script");
  s.src = "https://dafne.sirio.stbm.it/utility-fe/prod/libraries/MDAntiOverlap.min.js";
  s.async = true;
  s.onload = () => cb(window.MDAntiOverlap);
  s.onerror = onErr || (() => console.warn("[MDAntiOverlap] load failed"));
  document.head.appendChild(s);
}

/**
 * Log di debug CMP in console, disattivato di default.
 *
 * Attivazione (stesso origin del sito): in DevTools → Console (o Applicazione → Local storage)
 * eseguire `localStorage.setItem("AMECMP_DEBUG", "1")` con qualsiasi valore non vuoto, poi
 * ricaricare la pagina. I messaggi sono prefissati con `[AMECMP]`.
 *
 * Disattivazione: `localStorage.removeItem("AMECMP_DEBUG")` (o svuotare il valore), poi reload.
 * Se `localStorage` non è disponibile o genera errore, la funzione non fa nulla (try/catch interno).
 *
 * Tracciamento GA4 senza campionamento né lock di sessione (solo se il modulo è abilitato per l'host):
 * `localStorage.setItem("AMECMP_LOG_FORCE", "1")` + reload.
 * Disattivazione: `localStorage.removeItem("AMECMP_LOG_FORCE")`. Vedi `docs/cmp/CMP_REFERENCE.md`.
 */
function cmpDebug() {
  try {
    if (localStorage.getItem("AMECMP_DEBUG")) {
      var args = Array.prototype.slice.call(arguments);
      if (typeof args[0] === "string" && args[0].indexOf("EVENTO EMESSO") !== -1) {
        args.unshift("📣");
      }
      console.log.apply(console, ["[AMECMP]"].concat(args));
    }
  } catch (e) { /* localStorage non disponibile */ }
}

/**
 * Debug: forza l'invio degli hit `cmp_log_v{N}` saltando campionamento e lock di sessione.
 * Non bypassa `CMP_LOG_CONFIG.enabled`, origin non in lista, `mode: "off"` o assenza di gtag.
 * @returns {boolean}
 */
function isCmpLogForceTrace() {
  try {
    return !!localStorage.getItem("AMECMP_LOG_FORCE");
  } catch (e) {
    return false;
  }
}

/**
 * Se dopo il rendering resta il literal `%{total_number_of_ads_vendors}`, sostituisce con fallback.
 */
function applyIubVendorCountShortcodeFallback() {
  var root = document.getElementById("iubenda-cs-banner") || document.getElementById("ameConsentUI");
  if (!root || root.innerHTML.indexOf(IUB_VENDOR_COUNT_SHORTCODE) === -1) {
    return;
  }
  root.innerHTML = root.innerHTML.split(IUB_VENDOR_COUNT_SHORTCODE).join(String(IUB_VENDOR_COUNT_FALLBACK));
  cmpDebug(
    "applyIubVendorCountShortcodeFallback: shortcode vendor non espanso, usato fallback",
    IUB_VENDOR_COUNT_FALLBACK
  );
}

/** @type {boolean} - true dopo aver registrato il listener cascade su rilevazionevolumetrica */
var _cascadeSetupDone = false;
/** @type {boolean} - true se l'utente ha aperto il pannello Opzioni cookie (non rifiuto diretto da banner) */
var _panelWasOpened = false;
/** @type {boolean} - true durante onPreferenceExpressed (salvataggio da pannello opzioni), reset in onConsentRejected */
var _rejectedFromPanel = false;
/** @type {boolean} - true se al caricamento esisteva già il cookie di consenso iubenda */
var _hadConsentCookieOnLoad = false;
/** @type {boolean} - true se al load era presente cookie legacy con consent (true/false) ma senza mappa purposes */
var _hadLegacyNonPurposeCookieOnLoad = false;

(function initRilevazioneVolumetricaFlags() {
  var info = findIubendaConsentCookieInfo();
  _hadConsentCookieOnLoad = !!info;
  if (info && info.value) {
    try {
      var rawData = JSON.parse(info.value);
      var hasLegacyConsentFlagOnLoad = rawData && typeof rawData.consent !== "undefined";
      var hasPurposeMapOnLoad = !!(rawData && (rawData.purposes || (rawData.preferences && rawData.preferences.purposes)));
      _hadLegacyNonPurposeCookieOnLoad = !!(hasLegacyConsentFlagOnLoad && !hasPurposeMapOnLoad);
    } catch (e) {
      _hadLegacyNonPurposeCookieOnLoad = false;
    }
  }
  cmpDebug("[rilevazionevolumetrica] init - _hadConsentCookieOnLoad:", _hadConsentCookieOnLoad, "cookie:", info && info.name, "_hadLegacyNonPurposeCookieOnLoad:", _hadLegacyNonPurposeCookieOnLoad);
  /* --- BEGIN DAF-406: deve girare QUI, prima che il file inietti iubenda_cs.js --- */
  normalizzaVolumetricaPreDeploy(info);
  /* --- END DAF-406 --- */
})();

/**
 * ---------------------------------------------------------------------------
 * cmp_log_v2 — tracciamento GA4 campionato per sessione (CMP / consenso)
 * ---------------------------------------------------------------------------
 *
 * 1) Scopo: un solo evento GA4 (`cmp_log_v` + `CMP_LOG_CONFIG.version`)
 *    con campionamento stabile per tab (`sessionStorage`) e al massimo una hit
 *    per tipo di evento per sessione. `consent_granted` e `consent_rejected`
 *    condividono il lock `consent_decision`: la prima decisione vince.
 *
 * 2) Payload GA4 (parametri legacy + value):
 *    - `event_category`: "Nuovo" | "Gia_Consensato" (snapshot da `_hadConsentCookieOnLoad` al load).
 *    - `event_action`: stringa tipo azione (vedi mapping sotto).
 *    - `event_label`: hostname.
 *    - `value`: sample rate effettivo (0–100). Nota: in GA4 `value` ha semantica
 *      monetaria storica; qui trasporta solo il rate per evitare custom dimensions.
 *    - `non_interaction: true`.
 *
 * 3) Tipi (`eventType` interno → `event_action`):
 *    - `initial_state`     → "Stato_Iniziale"
 *    - `banner_shown`      → "Banner_Mostrato"
 *    - `consent_granted`   → "Consenso_Dato"   (stessi criteri di `tcf2Ready`)
 *    - `consent_rejected`  → "Consenso_Negato" (stessi criteri di `consentRejected`)
 *    - `options_opened`    → "Opzioni_Aperte"  (solo click dentro il banner)
 *
 * 4) Config: `CMP_LOG_CONFIG` — `version`, `enabled`, `defaultSampleRate`, `defaultMode`,
 *    `readyRetries`, `readyRetryDelay`, `origins` con override `{ sampleRate?, mode? }`.
 *    `mode`: "all" | "only_without_consent_cookie" (solo se `!_hadConsentCookieOnLoad`) |
 *    alias "only_no_consent" | "off".
 *
 * 5) sessionStorage (prefisso da version):
 *    - `cmp_log_v{N}_sampled` → "true" | "false" (decisione una volta per sessione).
 *    - `cmp_log_v{N}_sent__<lockKey>` → "1" dopo invio.
 *
 * 6) Gate gtag: `isGtagReady()` richiede stub `gtag` e almeno un `['config','G-*'|'GT-*']`
 *    nel dataLayer (evita eventi persi se network.common gira prima di `gtag('config',...)`).
 *    Retry su `gtag_not_ready` per tutti gli eventType (readyRetries × readyRetryDelay).
 *    Il campionamento viene deciso solo dopo che il gate gtag è passato.
 *
 * 7) Debug console: `AMECMP_DEBUG` + reload → log `[AMECMP]` / `[cmp_log_v{N}]`.
 *    Forza tracciamento (no campionamento, no lock): `AMECMP_LOG_FORCE` + reload, se modulo e origin
 *    abilitati. Non disattiva filtri `mode` né il gate `gtag` ready.
 *
 * 8) Criteri consenso: allineati a `emitConsentStateEvent("ready"|"rejected")` e
 *    `areConsentPurposesGranted` (purpose CMP da config + purpose TCF da config).
 *
 * @namespace
 */
var cmpLogV2 = (function cmpLogV2Module() {
  var STORAGE_SAMPLE = "cmp_log_v" + CMP_LOG_CONFIG.version + "_sampled";
  var STORAGE_SENT_PREFIX = "cmp_log_v" + CMP_LOG_CONFIG.version + "_sent__";
  var _initDone = false;
  var _memSampled = null;
  var _readyRetries = {};
  var _sampleReuseLogged = false;
  var _consentBurstUntil = 0;
  var _consentBurstWindowMs = 800;

  /**
   * Nome evento GA4 derivato da `CMP_LOG_CONFIG.version`.
   * @returns {string}
   */
  function getEventName() {
    return "cmp_log_v" + CMP_LOG_CONFIG.version;
  }

  /**
   * Prefisso log cmpDebug derivato da version.
   * @returns {string}
   */
  function getLogTag() {
    return "[cmp_log_v" + CMP_LOG_CONFIG.version + "]";
  }

  /**
   * true se gtag è disponibile e nel dataLayer esiste almeno un config GA4 (G-* o GT-*).
   * @returns {boolean}
   */
  function isGtagReady() {
    if (typeof gtag !== "function") return false;
    var dl = typeof dataLayer !== "undefined" ? dataLayer : null;
    if (!dl || typeof dl.length !== "number") return false;
    for (var i = 0; i < dl.length; i++) {
      var e = dl[i];
      if (e && e[0] === "config" && typeof e[1] === "string" && (e[1].indexOf("G-") === 0 || e[1].indexOf("GT-") === 0)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Chiave origin in `CMP_LOG_CONFIG.origins` più specifica per l'host corrente.
   * @returns {string|null}
   */
  function getMatchedOriginKey() {
    var origins = CMP_LOG_CONFIG.origins || {};
    var host = location.hostname;
    var best = null;
    for (var k in origins) {
      if (!Object.prototype.hasOwnProperty.call(origins, k)) continue;
      if (host.indexOf(k) !== -1) {
        if (!best || k.length > best.length) best = k;
      }
    }
    return best;
  }

  /**
   * Config effettiva per l'host corrente (merge default + override).
   * @returns {{ enabled: boolean, sampleRate: number, mode: string }}
   */
  function getOriginConfig() {
    if (!CMP_LOG_CONFIG.enabled) {
      return { enabled: false, sampleRate: 0, mode: "off" };
    }
    var key = getMatchedOriginKey();
    if (!key) {
      return { enabled: false, sampleRate: 0, mode: "off" };
    }
    var o = CMP_LOG_CONFIG.origins[key] || {};
    var sampleRate =
      typeof o.sampleRate === "number" && !isNaN(o.sampleRate)
        ? o.sampleRate
        : CMP_LOG_CONFIG.defaultSampleRate;
    var mode = o.mode != null ? String(o.mode) : String(CMP_LOG_CONFIG.defaultMode || "all");
    sampleRate = Math.max(0, Math.min(100, Math.round(sampleRate)));
    if (mode === "off") {
      return { enabled: false, sampleRate: sampleRate, mode: "off" };
    }
    return { enabled: true, sampleRate: sampleRate, mode: mode };
  }

  /**
   * Lock key per dedup sessione (granted/rejected condividono `consent_decision`).
   * @param {string} eventType
   * @returns {string|null}
   */
  function lockKeyFor(eventType) {
    if (eventType === "initial_state") return "initial_state";
    if (eventType === "banner_shown") return "banner_shown";
    if (eventType === "consent_granted" || eventType === "consent_rejected") return "consent_decision";
    if (eventType === "options_opened") return "options_opened";
    /* --- BEGIN DAF-406 --- */
    if (eventType === "volumetrica_normalizzata") return "volumetrica_normalizzata";
    /* --- END DAF-406 --- */
    return null;
  }

  /**
   * @param {string} lockKey
   * @returns {boolean}
   */
  function isLockTaken(lockKey) {
    try {
      return sessionStorage.getItem(STORAGE_SENT_PREFIX + lockKey) === "1";
    } catch (e) {
      return false;
    }
  }

  /**
   * @param {string} lockKey
   */
  function setLock(lockKey) {
    try {
      sessionStorage.setItem(STORAGE_SENT_PREFIX + lockKey, "1");
    } catch (e) { /* ignore */ }
  }

  /**
   * @param {string} mode
   * @returns {boolean}
   */
  function isModeAllowed(mode) {
    if (mode === "off") return false;
    if (mode === "only_without_consent_cookie" || mode === "only_no_consent") {
      return !_hadConsentCookieOnLoad;
    }
    return true;
  }

  /**
   * Campionamento stabile per sessione.
   * @param {number} sampleRate
   * @returns {boolean}
   */
  function isSessionSampled(sampleRate) {
    if (sampleRate >= 100) return true;
    if (sampleRate <= 0) return false;
    try {
      var cur = sessionStorage.getItem(STORAGE_SAMPLE);
      if (cur === "true" || cur === "false") {
        if (!_sampleReuseLogged) {
          _sampleReuseLogged = true;
          cmpDebug(getLogTag() + " ⚠️ campionamento sessione - riuso decisione precedente - sampled:", cur === "true", "sampleRate:", sampleRate);
        }
        return cur === "true";
      }
      var sampled = Math.random() * 100 < sampleRate;
      sessionStorage.setItem(STORAGE_SAMPLE, sampled ? "true" : "false");
      cmpDebug(getLogTag() + " ⚠️ campionamento sessione - sampled:", sampled, "sampleRate:", sampleRate);
      return sampled;
    } catch (e) {
      if (_memSampled === null) {
        _memSampled = Math.random() * 100 < sampleRate;
        cmpDebug(getLogTag() + " ⚠️ campionamento sessione (fallback memoria) - sampled:", _memSampled, "sampleRate:", sampleRate);
      }
      return _memSampled;
    }
  }

  /**
   * Log una tantum all'avvio del primo emit.
   */
  function ensureInitLogged() {
    if (_initDone) return;
    _initDone = true;
    var cfg = getOriginConfig();
    cmpDebug(
      getLogTag() + " ⚠️ init - host:",
      location.hostname,
      "resolved:",
      { enabled: cfg.enabled, sampleRate: cfg.sampleRate, mode: cfg.mode },
      "forceTrace:",
      isCmpLogForceTrace(),
      "_hadConsentCookieOnLoad:",
      _hadConsentCookieOnLoad
    );
  }

  /**
   * Valuta se l'evento può essere inviato; non modifica stato.
   * @param {string} eventType
   * @returns {{ ok: boolean, reason?: string, cfg?: object, lockKey?: string }}
   */
  function canEmit(eventType) {
    ensureInitLogged();
    if (!CMP_LOG_CONFIG.enabled) {
      return { ok: false, reason: "module_disabled" };
    }
    var cfg = getOriginConfig();
    if (!cfg.enabled) {
      return { ok: false, reason: "origin_disabled", cfg: cfg };
    }
    if (cfg.mode === "off") {
      return { ok: false, reason: "mode_off", cfg: cfg };
    }
    if (!isModeAllowed(cfg.mode)) {
      return { ok: false, reason: "mode_requires_no_consent", cfg: cfg };
    }
    if (!isGtagReady()) {
      return { ok: false, reason: "gtag_not_ready", cfg: cfg, lockKey: lockKeyFor(eventType) };
    }
    var forceTrace = isCmpLogForceTrace();
    if (!forceTrace && !isSessionSampled(cfg.sampleRate)) {
      return { ok: false, reason: "not_sampled", cfg: cfg };
    }
    var lockKey = lockKeyFor(eventType);
    if (!lockKey) {
      return { ok: false, reason: "origin_disabled", cfg: cfg };
    }
    if (!forceTrace && isLockTaken(lockKey)) {
      return { ok: false, reason: "lock_already_taken", cfg: cfg, lockKey: lockKey };
    }
    return { ok: true, cfg: cfg, lockKey: lockKey, forceTrace: forceTrace };
  }

  /**
   * Invia hit GA4 se i gate passano; dedup via lock dopo conferma invio.
   * @param {string} eventType
   * @param {string} action valore di `event_action`
   * @returns {boolean} true se inviato
   */
  function emit(eventType, action) {
    if (eventType === "consent_granted" || eventType === "consent_rejected") {
      var nowBurst = Date.now();
      if (nowBurst < _consentBurstUntil) {
        cmpDebug(getLogTag() + " skip emit (burst dedup) - eventType:", eventType);
        return false;
      }
      _consentBurstUntil = nowBurst + _consentBurstWindowMs;
    }

    var cat = _hadConsentCookieOnLoad ? "Gia_Consensato" : "Nuovo";
    var check = canEmit(eventType);
    var lockKey = check.lockKey || lockKeyFor(eventType);
    var lockTaken = lockKey ? isLockTaken(lockKey) : false;

    cmpDebug(
      getLogTag() + " tentativo emit - eventType:",
      eventType,
      "action:",
      action,
      "lockKey:",
      lockKey,
      "lockPreso:",
      lockTaken,
      "category:",
      cat
    );

    if (!check.ok) {
      var reason = check.reason || "origin_disabled";
      if (reason === "lock_already_taken" && lockKey === "consent_decision") {
        cmpDebug(
          getLogTag() + " ❌ skip emit - eventType:",
          eventType,
          "motivo:",
          "lock_already_taken (consent_decision gia preso, es. consent_granted vs consent_rejected nella stessa sessione)"
        );
      } else {
        cmpDebug(getLogTag() + " ❌ skip emit - eventType:", eventType, "motivo:", reason);
      }
      if (reason === "gtag_not_ready") {
        var maxRetries = typeof CMP_LOG_CONFIG.readyRetries === "number" ? CMP_LOG_CONFIG.readyRetries : 60;
        var retryDelay = typeof CMP_LOG_CONFIG.readyRetryDelay === "number" ? CMP_LOG_CONFIG.readyRetryDelay : 500;
        var retries = _readyRetries[eventType] || 0;
        if (retries < maxRetries) {
          _readyRetries[eventType] = retries + 1;
          setTimeout(function () {
            emit(eventType, action);
          }, retryDelay);
        }
      }
      return false;
    }

    var cfg = check.cfg;
    var params = {
      event_category: cat,
      event_action: action,
      event_label: window.location.hostname,
      value: cfg.sampleRate,
      non_interaction: true
    };

    cmpDebug(
      getLogTag() + " ✅",
      check.forceTrace ? "forceTrace emit" : "lock acquisito",
      "- lockKey:",
      lockKey,
      "(eventType:",
      eventType,
      ")"
    );
    try {
      gtag("event", getEventName(), params);
      if (!check.forceTrace) {
        setLock(lockKey);
      }
    } catch (err) {
      cmpDebug(getLogTag() + " ❌ gtag errore - eventType:", eventType, err);
      return false;
    }
    cmpDebug(getLogTag() + " EVENTO EMESSO - " + getEventName(), params);
    return true;
  }

  return {
    emit: emit,
    getOriginConfig: getOriginConfig,
    getMatchedOriginKey: getMatchedOriginKey,
    isGtagReady: isGtagReady
  };
})();

(function cmpLogV2EmitInitialState() {
  cmpLogV2.emit("initial_state", "Stato_Iniziale");
})();

/**
 * Legge un cookie per nome.
 * @param {string} name - Nome del cookie
 * @returns {string|null} Valore decodificato o null se assente
 */
function getCookie(name) {
  var match = document.cookie.match(
    RegExp("(?:^|;\\s*)" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Trova il cookie di consenso Iubenda nel formato corretto.
 *
 * Iubenda usa due possibili nomi:
 *  - "_iub_cs-s<siteId>" per property gestite via feature "Sites"
 *    (es. fattoincasadabenedetta.it: "_iub_cs-s3918385");
 *  - "_iub_cs-<cookiePolicyId>" per property classiche.
 *
 * @returns {{name: string, value: string}|null}
 */
function findIubendaConsentCookieInfo() {
  var siteId = ameCp && ameCp.siteIdValue;
  var cookiePolicyId = ameCp && ameCp.cookiePolicyIdValue;
  if (siteId) {
    var nameSite = "_iub_cs-s" + siteId;
    var valueSite = getCookie(nameSite);
    if (valueSite) return { name: nameSite, value: valueSite };
  }
  if (cookiePolicyId) {
    var nameCpl = "_iub_cs-" + cookiePolicyId;
    var valueCpl = getCookie(nameCpl);
    if (valueCpl) return { name: nameCpl, value: valueCpl };
  }
  return null;
}

/**
 * Restituisce gli ID dei purpose additional (escluso rilevazionevolumetrica) da cascadare.
 * Quando rilevazionevolumetrica viene disattivato, questi vengono spenti automaticamente.
 * @returns {string[]}
 */
function getPurposesToCascade() {
  var config = window._iub && window._iub.csConfiguration && window._iub.csConfiguration.additionalPurposes;
  if (!config || !Array.isArray(config)) return [];
  return config
    .map(function (p) { return p && p.id; })
    .filter(function (id) { return id && id !== "rilevazionevolumetrica"; });
}

/**
 * Restituisce il document del pannello preferenze (iframe iubenda) o document principale.
 * @returns {Document}
 */
function getPreferenceDoc() {
  var ifr = document.getElementById("iubenda-iframe") || document.querySelector("#iubenda-cs-banner iframe");
  if (ifr && ifr.contentDocument) return ifr.contentDocument;
  return document;
}

/**
 * Trova l'elemento toggle (checkbox o switch) per un purpose dato.
 * @param {string} purposeId - ID del purpose (es. "rilevazionevolumetrica")
 * @param {Document} [doc] - Document dove cercare (default: getPreferenceDoc())
 * @returns {Element|null}
 */
function findPurposeToggle(purposeId, doc) {
  doc = doc || getPreferenceDoc();
  return doc.querySelector("#purpose-" + purposeId) || doc.querySelector("input[name=\"" + purposeId + "\"]");
}

/**
 * Verifica se un toggle è attivo (checked o aria-checked o classi active/on).
 * @param {Element|null} el - Elemento toggle
 * @returns {boolean}
 */
function isToggleOn(el) {
  if (!el) return false;
  if (el.type === "checkbox") return el.checked;
  return el.getAttribute("aria-checked") === "true" || el.classList.contains("active") || el.classList.contains("on");
}

/**
 * Legge lo stato dei purpose additional (SDK Nielsen/Auditel, rilevazione volumetrica, ecc.)
 * prima dall'API iubenda, poi dal cookie come fallback.
 * @returns {{sdkvideonielsen: boolean, sdkvideoauditel: boolean, sdktesto: boolean, pairingping: boolean, rilevazionevolumetrica: boolean}}
 */
function getAdditionalPurposesState() {
  var prefs = {
    sdkvideonielsen: false,
    sdkvideoauditel: false,
    sdktesto: false,
    pairingping: false,
    rilevazionevolumetrica: true
  };
  if (window._iub && window._iub.cs && typeof window._iub.cs.api !== "undefined" && window._iub.cs.api.getPreferences) {
    try {
      var apiPrefs = window._iub.cs.api.getPreferences();
      if (apiPrefs && apiPrefs.purposes) {
        var p = apiPrefs.purposes;
        if (typeof p.sdkvideonielsen !== "undefined") prefs.sdkvideonielsen = !!p.sdkvideonielsen;
        if (typeof p.sdkvideoauditel !== "undefined") prefs.sdkvideoauditel = !!p.sdkvideoauditel;
        if (typeof p.sdktesto !== "undefined") prefs.sdktesto = !!p.sdktesto;
        if (typeof p.pairingping !== "undefined") prefs.pairingping = !!p.pairingping;
        if (typeof p.rilevazionevolumetrica !== "undefined") prefs.rilevazionevolumetrica = !!p.rilevazionevolumetrica;
        return prefs;
      }
    } catch (e) {
      cmpDebug("getAdditionalPurposesState API non disponibile:", e);
    }
  }
  var info = findIubendaConsentCookieInfo();
  if (!info) return prefs;
  try {
    var data = JSON.parse(info.value);
    var purposes = data.purposes || (data.preferences && data.preferences.purposes) || {};
    if (typeof purposes.sdkvideonielsen !== "undefined") prefs.sdkvideonielsen = !!purposes.sdkvideonielsen;
    if (typeof purposes.sdkvideoauditel !== "undefined") prefs.sdkvideoauditel = !!purposes.sdkvideoauditel;
    if (typeof purposes.sdktesto !== "undefined") prefs.sdktesto = !!purposes.sdktesto;
    if (typeof purposes.pairingping !== "undefined") prefs.pairingping = !!purposes.pairingping;
    if (typeof purposes.rilevazionevolumetrica !== "undefined") prefs.rilevazionevolumetrica = !!purposes.rilevazionevolumetrica;
  } catch (e) {
    cmpDebug("Errore parsing cookie purpose:", e);
  }
  return prefs;
}

/**
 * Forza rilevazionevolumetrica=true via API iubenda.
 * Usato solo quando l'utente vergine clicca "Nega tutto" direttamente dal banner.
 * Fallback su cookie se l'API non è disponibile.
 */
function forceRilevazioneVolumetricaTrueViaApi() {
  var api = window._iub && window._iub.cs && window._iub.cs.api;
  if (!api || !api.getPreferences || !api.setPreferences) {
    forceRilevazioneVolumetricaTrueFallback();
    return;
  }
  try {
    var prefs = api.getPreferences();
    if (!prefs) return;
    var purposes = prefs.purposes || {};
    purposes.rilevazionevolumetrica = true;
    api.setPreferences({ purposes: purposes }, false);
    cmpDebug("rilevazionevolumetrica normalizzato a true via API (Nega tutto da vergine)");
  } catch (e) {
    cmpDebug("forceRilevazioneVolumetricaTrueViaApi:", e);
    forceRilevazioneVolumetricaTrueFallback();
  }
}

/**
 * Fallback: forza rilevazionevolumetrica=true scrivendo direttamente il cookie iubenda.
 * Usato quando l'API setPreferences non è disponibile.
 */
function forceRilevazioneVolumetricaTrueFallback() {
  var info = findIubendaConsentCookieInfo();
  if (!info) return;
  try {
    var data = JSON.parse(info.value);
    var purposes = data.purposes || (data.preferences && data.preferences.purposes) || {};
    if (!data.purposes) data.purposes = purposes;
    purposes.rilevazionevolumetrica = true;
    var expires = 365 * 24 * 60 * 60;
    document.cookie = info.name + "=" + encodeURIComponent(JSON.stringify(data)) + "; path=/; max-age=" + expires + "; SameSite=Lax";
    cmpDebug("rilevazionevolumetrica normalizzato a true (fallback cookie)");
  } catch (e) {
    cmpDebug("forceRilevazioneVolumetricaTrueFallback:", e);
  }
}

/**
 * Configura il cascade: quando l'utente disattiva "Rilevazione volumetrica" nel pannello,
 * vengono automaticamente disattivati anche gli altri purpose (SDK Nielsen, Auditel, ecc.).
 * Chiamato da on2ndLayerShown. Usa retry con setTimeout se il DOM non è pronto.
 */

/**
 * Normalizza rilevazionevolumetrica=true per utenti con cookie legacy non purpose-based.
 * Caso target: cookie consenso già presente (consent true/false), ma senza mappa purposes.
 */
function normalizeLegacyConsentGivenRilevazioneVolumetrica() {
  // Normalizziamo sulla base dello stato rilevato al load, prima di eventuali migrazioni cookie Iubenda.
  if (!_hadLegacyNonPurposeCookieOnLoad) return;
  cmpDebug("[rilevazionevolumetrica] legacy non purpose-based rilevato al load: normalizzo a true");
  forceRilevazioneVolumetricaTrueViaApi();
}

/* --- BEGIN DAF-406: normalizzazione volumetrica pre-deploy (MODULO A TERMINE) --- */

/**
 * Dominio registrabile dedotto dall'hostname: le ultime due etichette, salvo i
 * suffissi a due livelli, dove ne servono tre (`co.uk`, `com.br`, ...).
 *
 * E' un ripiego, non la fonte principale: si usa solo quando la configurazione
 * non dichiara `localConsentDomain`, cioe' quando anche Iubenda deduce da se'.
 * I domini a suffisso composto presenti in configurazione (`giallozafferano.com.br`,
 * `hi.giallozafferano.in`) impostano `localConsentDomain` sull'host completo e
 * quindi non passano mai di qui: la lista sotto e' una cintura, non la bretella.
 *
 * @param {string} host
 * @returns {string}
 */
function dominioRegistrabileDaHost(host) {
  var h = String(host || "");
  /* Indirizzo IP o IPv6: l'attributo domain non e' ammesso, si rinuncia. */
  if (!h || h.indexOf(":") > -1 || /^[0-9.]+$/.test(h)) return "";
  var parti = h.split(".");
  if (parti.length <= 2) return parti.join(".");
  var suffissiComposti = { co: 1, com: 1, net: 1, org: 1, edu: 1, gov: 1, ac: 1, or: 1, ne: 1 };
  var penultima = parti[parti.length - 2];
  var ultima = parti[parti.length - 1];
  /* `com.br` si', `giallozafferano.com` no: il secondo livello conta come
     suffisso solo quando il TLD e' un codice paese di due lettere. */
  if (ultima.length === 2 && suffissiComposti[penultima] && parti.length >= 3) {
    return parti.slice(-3).join(".");
  }
  return parti.slice(-2).join(".");
}

/**
 * Domini su cui tentare la scrittura, in ordine di probabilita'.
 *
 * Il dominio DEVE essere quello su cui vive il cookie esistente: scriverne uno
 * diverso non lo aggiorna, ne crea un secondo che lo ombreggia. E non e'
 * deducibile con certezza, perche' `document.cookie` non espone il dominio di
 * provenienza e perche' un sottodominio VEDE il cookie del dominio padre.
 *
 * Misurato il 2026-09-22 su blog.giallozafferano.it: la configurazione dichiara
 * `localConsentDomain = "blog.giallozafferano.it"`, ma il cookie effettivamente
 * leggibile era su `giallozafferano.it`, ereditato dal dominio padre. Fidarsi
 * del solo valore dichiarato avrebbe prodotto un'ombra a ogni caricamento.
 *
 * Quindi si prova in ordine e si riconosce il dominio giusto dall'esito: solo
 * la scrittura sul dominio esatto SOSTITUISCE il cookie invece di affiancarne
 * un secondo, cioe' solo li' il conteggio resta 1.
 *
 * @returns {string[]}
 */
function dominiCandidatiNormalizzazione() {
  var candidati = [];
  function aggiungi(d) {
    if (d && candidati.indexOf(d) === -1) candidati.push(d);
  }
  aggiungi((typeof ameCp !== "undefined" && ameCp) ? ameCp.localConsentDomain : null);
  /* dal piu' specifico al dominio registrabile: copre il caso del cookie
     ereditato dal padre e quello del cookie scritto sul sottodominio */
  var registrabile = dominioRegistrabileDaHost(location.hostname);
  if (registrabile) {
    var parti = String(location.hostname).split(".");
    var minimo = registrabile.split(".").length;
    for (var i = 0; parti.length - i >= minimo; i++) aggiungi(parti.slice(i).join("."));
  }
  return candidati;
}

/**
 * True quando il modulo ha superato la propria data di spegnimento.
 * @returns {boolean}
 */
function moduloVolumetricaScaduto() {
  var limite = Date.parse(NORMALIZZA_VOLUMETRICA_CONFIG.scadenzaModulo);
  return !isNaN(limite) && Date.now() >= limite;
}

/**
 * Quante volte compare un cookie con questo nome. Piu' di una significa che ne
 * esistono due con dominio o path diversi: il secondo ombreggia il primo.
 * @param {string} nome
 * @returns {number}
 */
function occorrenzeCookie(nome) {
  var esc = nome.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1");
  var trovate = document.cookie.match(RegExp("(?:^|;\\s*)" + esc + "=", "g"));
  return trovate ? trovate.length : 0;
}

/**
 * Normalizza `rilevazionevolumetrica` a true sul cookie pre-deploy.
 *
 * Gira SINCRONA dentro `initRilevazioneVolumetricaFlags`, cioe' prima che questo
 * stesso file inietti `iubenda_cs.js`. Iubenda si idrata dal cookie al boot:
 * trovandolo gia' corretto, memoria, pannello e `getCustomPurposesState()`
 * nascono coerenti e non serve chiamare `setPreferences` (che riscriverebbe il
 * cookie con la data di oggi, perdendo la data reale di espressione).
 *
 * @param {{name: string, value: string}|null} info - cookie gia' letto dal chiamante
 */
function normalizzaVolumetricaPreDeploy(info) {
  var cfg = NORMALIZZA_VOLUMETRICA_CONFIG;
  if (!cfg || !cfg.enabled) return;
  if (moduloVolumetricaScaduto()) {
    cmpDebug("[DAF-406] modulo scaduto (" + cfg.scadenzaModulo + "), nessuna normalizzazione");
    return;
  }

  var candidati = dominiCandidatiNormalizzazione();
  if (!candidati.length) return;

  /* Il cookie va scritto Secure: su http il browser lo scarterebbe in silenzio. */
  if (location.protocol !== "https:") return;

  /* La pagina puo' caricare una PROPRIA copia di iubenda_cs.js in parallelo a
     questo file (osservato in produzione su www.sorrisi.com: cdn.iubenda.com/cs/
     iubenda_cs.js parte insieme a network.common.media.js, mentre la copia
     iniettata da noi e' quella sotto /cs/stable/). Quando quella copia vince la
     corsa, _iub.cs.api esiste gia' qui.
     NON e' un motivo per rinunciare: il tag Nielsen legge il COOKIE, non la
     memoria della libreria, quindi la scrittura serve comunque. Cio' che si
     perde e' solo la coerenza della memoria su QUESTA pageview - pannello e
     getCustomPurposesState() restano indietro fino al caricamento successivo.
     Il caso viene marcato nell'esito per poterne misurare la frequenza. */
  var apiGiaAttiva = !!(window._iub && window._iub.cs && window._iub.cs.api);

  try {
    if (window.localStorage && window.localStorage.getItem(CHIAVE_MARCATORE_VOLUMETRICA)) {
      return;
    }
  } catch (e) {
    /* localStorage non disponibile: si procede, la scrittura e' idempotente nel risultato */
  }

  if (!info || !info.value) return;

  var data;
  try {
    data = JSON.parse(info.value);
  } catch (e) {
    _esitoNormalizzazioneVolumetrica = "parse_fallito";
    cmpDebug("[DAF-406] parse del cookie fallito:", e);
    return;
  }

  var purposes = data && (data.purposes || (data.preferences && data.preferences.purposes));
  if (!purposes || purposes.rilevazionevolumetrica !== false) return;

  var scritto = data.timestamp ? Date.parse(data.timestamp) : NaN;
  var limite = Date.parse(cfg.cutoff);
  if (isNaN(scritto) || isNaN(limite) || scritto >= limite) return;

  /* Residuo di scadenza calcolato dalla data di scrittura, non azzerato a nuovo. */
  var residuo = Math.floor((scritto + GIORNI_COOKIE_IUBENDA * 86400000 - Date.now()) / 1000);
  if (residuo <= 0) return;

  _meseCookieNormalizzato = String(data.timestamp).slice(0, 7);
  var originale = data.timestamp;

  purposes.rilevazionevolumetrica = true;
  if (!data.purposes) data.purposes = purposes;

  /* Attributi identici a quelli con cui Iubenda scrive il cookie, verificati su
     www.sorrisi.com il 2026-09-17. Sbagliarne uno crea un secondo cookie che
     ombreggia il primo: da li' in poi www e programma vedrebbero consensi diversi.

     Il dominio si riconosce dall'esito: si prova un candidato alla volta e si
     tiene quello per cui il cookie resta UNO SOLO, cioe' quello che ha
     sostituito l'originale invece di affiancarlo. Ogni tentativo fallito viene
     rimosso subito, e rimuove solo il cookie appena creato: quello originale
     sta su un altro dominio e non viene toccato. */
  var payload = info.name + "=" + encodeURIComponent(JSON.stringify(data));
  var dominio = null;
  for (var i = 0; i < candidati.length; i++) {
    var tentativo = candidati[i];
    document.cookie = payload + "; path=/; domain=" + tentativo + "; max-age=" + residuo + "; SameSite=None; Secure";
    if (occorrenzeCookie(info.name) === 1) { dominio = tentativo; break; }
    document.cookie = info.name + "=; path=/; domain=" + tentativo + "; max-age=0; SameSite=None; Secure";
    cmpDebug("[DAF-406] dominio scartato perche' avrebbe ombreggiato il cookie:", tentativo);
  }

  if (!dominio) {
    _esitoNormalizzazioneVolumetrica = "ombra_rilevata";
    cmpDebug("[DAF-406] nessun dominio candidato sostituisce il cookie, scrittura annullata");
    return;
  }

  var verifica = getCookie(info.name);
  var okScrittura = false;
  try {
    var riletto = JSON.parse(verifica);
    var p = riletto && (riletto.purposes || (riletto.preferences && riletto.preferences.purposes));
    okScrittura = !!(p && p.rilevazionevolumetrica === true);
  } catch (e) {
    okScrittura = false;
  }
  if (!okScrittura) {
    _esitoNormalizzazioneVolumetrica = "scrittura_fallita";
    cmpDebug("[DAF-406] il cookie riletto non riporta il valore atteso");
    return;
  }

  /* Senza marcatore la normalizzazione si ripete a ogni caricamento: innocua nel
     risultato, ma va segnalata nella misura perche' gonfia il conteggio. */
  _esitoNormalizzazioneVolumetrica = "storage_assente";
  try {
    if (window.localStorage) {
      window.localStorage.setItem(CHIAVE_MARCATORE_VOLUMETRICA, originale);
      _esitoNormalizzazioneVolumetrica = "ok";
    }
  } catch (e) {
    cmpDebug("[DAF-406] marcatore non salvato:", e);
  }
  if (apiGiaAttiva) {
    _esitoNormalizzazioneVolumetrica += "_api_attiva";
  }
  cmpDebug("[DAF-406] volumetrica normalizzata - espressione originale:", originale, "esito:", _esitoNormalizzazioneVolumetrica);
}

/**
 * Emette l'evento GA4 con l'esito. Chiamata da `onReady`, non dall'init:
 * a quel punto `cmpLogV2` esiste ed e' piu' probabile che `gtag` sia pronto.
 */
function emitEsitoNormalizzazioneVolumetrica() {
  if (!_esitoNormalizzazioneVolumetrica) return;
  if (typeof cmpLogV2 === "undefined" || !cmpLogV2 || typeof cmpLogV2.emit !== "function") return;
  cmpLogV2.emit(
    "volumetrica_normalizzata",
    "Volumetrica_Normalizzata | " + (_meseCookieNormalizzato || "n/d") + " | " + _esitoNormalizzazioneVolumetrica
  );
}
/* --- END DAF-406 --- */

/* --- BEGIN DAF-379: migrazione consenso legacy --- */
var _legacyConsentMigrationStorageKey = "_iub_legacy_consent_migrated";

function migrateLegacyFullConsent() {
  if (!_hadLegacyNonPurposeCookieOnLoad) return;

  try {
    if (window.localStorage && window.localStorage.getItem(_legacyConsentMigrationStorageKey) === "1") {
      cmpDebug("[DAF-379] Migrazione legacy gia' eseguita, skip");
      return;
    }
  } catch (e) {
    cmpDebug("[DAF-379] Impossibile leggere localStorage:", e);
  }

  var info = findIubendaConsentCookieInfo();
  if (!info) return;
  try {
    var data = JSON.parse(info.value);
    if (!data || data.consent !== true) {
      cmpDebug("[DAF-379] Cookie legacy con consent !== true, skip migrazione");
      return;
    }
  } catch (e) { return; }

  var api = window._iub && window._iub.cs && window._iub.cs.api;
  if (!api || typeof api.setPreferences !== "function") {
    cmpDebug("[DAF-379] API setPreferences non disponibile, skip migrazione");
    return;
  }

  var purposesObj = { "1": true, "2": true, "3": true, "4": true, "5": true };
  var apConfig = window._iub && window._iub.csConfiguration && window._iub.csConfiguration.additionalPurposes;
  if (Array.isArray(apConfig) && apConfig.length > 0) {
    for (var i = 0; i < apConfig.length; i++) {
      if (apConfig[i] && apConfig[i].id) {
        purposesObj[String(apConfig[i].id)] = true;
      }
    }
  }

  try {
    api.setPreferences({
      consent: true,
      purposes: purposesObj,
      tcfv2: { all: true },
      gac: { all: true }
    }, true);
    try {
      if (window.localStorage) {
        window.localStorage.setItem(_legacyConsentMigrationStorageKey, "1");
      }
    } catch (e) {
      cmpDebug("[DAF-379] Impossibile scrivere localStorage:", e);
    }
    cmpDebug("[DAF-379] Migrazione consenso legacy completata");
  } catch (e) {
    cmpDebug("[DAF-379] Errore migrazione consenso legacy:", e);
  }
}
/* --- END DAF-379: migrazione consenso legacy --- */

function setupRilevazioneVolumetricaCascade() {
  if (_cascadeSetupDone) return;
  cmpDebug("setupRilevazioneVolumetricaCascade chiamato (on2ndLayerShown)");

  var doc = getPreferenceDoc();
  _cascadeSetupDone = true;
  cmpDebug("Cascade setup ok, event delegation su document");

  doc.addEventListener("change", function (e) {
    var t = e.target;
    if (!t || (t.id !== "purpose-rilevazionevolumetrica" && t.name !== "rilevazionevolumetrica")) return;

    if (!isToggleOn(t)) {
      cmpDebug("Rilevazione volumetrica OFF -> disattivo altri purpose");
      var d = getPreferenceDoc();
      getPurposesToCascade().forEach(function (id) {
        var el = findPurposeToggle(id, d);
        if (el && isToggleOn(el)) {
          cmpDebug("Cascade click su", id);
          el.click();
        }
      });
    }
  }, true);
}

/** @type {boolean} - true dopo aver registrato il listener per il bottone back */
var _backButtonListenerSetup = false;

/**
 * Registra un listener per rilevare il click sul bottone "back" nel pannello opzioni.
 * Quando viene cliccato, resetta _panelWasOpened=false così onConsentRejected può forzare rilevazionevolumetrica=true
 * se l'utente nega dal banner principale dopo essere tornato indietro.
 * Chiamato da on2ndLayerShown. Usa retry con setTimeout se il DOM non è pronto.
 */
function setupBackButtonDetection() {
  if (_backButtonListenerSetup) return;
  cmpDebug("[rilevazionevolumetrica] setupBackButtonDetection chiamato (on2ndLayerShown) - _panelWasOpened corrente:", _panelWasOpened);

  var doc = getPreferenceDoc();
  _backButtonListenerSetup = true;

  doc.addEventListener("click", function (e) {
    var target = e.target;
    if (!target) return;

    var backButton = target.closest && target.closest("button.iub-btn-back, button.purposes-btn-back");
    if (!backButton) {
      if (target.tagName === "BUTTON" &&
          (target.classList.contains("iub-btn-back") || target.classList.contains("purposes-btn-back"))) {
        backButton = target;
      }
    }

    if (backButton) {
      var oldValue = _panelWasOpened;
      _panelWasOpened = false;
      cmpDebug("[rilevazionevolumetrica] ⚠️ CLICK SU BOTTONE BACK RILEVATO - _panelWasOpened cambiato da", oldValue, "a", _panelWasOpened, "target:", target, "backButton:", backButton);
    }
  }, true);

  cmpDebug("[rilevazionevolumetrica] ✅ Event delegation per back button registrato sul document con capture phase");
}

var _preferenceSideEffectsTimer = null;
var _preferenceSideEffectsDelayMs = 500;
var _preferenceSideEffectsSource = "onPreferenceExpressed";
var _preferenceSideEffectsLastPreference = null;

/**
 * Accorpa customPurposesStateChange + ameConsentChanged dopo onPreferenceExpressed.
 * @param {string} [source]
 * @param {object} [preference]
 */
function schedulePreferenceSideEffects(source, preference) {
  _preferenceSideEffectsSource = source || "onPreferenceExpressed";
  _preferenceSideEffectsLastPreference = preference;
  if (_preferenceSideEffectsTimer) {
    clearTimeout(_preferenceSideEffectsTimer);
  }
  _preferenceSideEffectsTimer = setTimeout(function () {
    _preferenceSideEffectsTimer = null;
    var src = _preferenceSideEffectsSource;
    var pref = _preferenceSideEffectsLastPreference;
    _preferenceSideEffectsLastPreference = null;

    var purposes = getAdditionalPurposesState();
    cmpDebug("EVENTO EMESSO: customPurposesStateChange", src, purposes);
    try {
      window.dispatchEvent(
        new CustomEvent("customPurposesStateChange", {
          detail: { purposes: purposes, source: src }
        })
      );
    } catch (e) {
      cmpDebug("schedulePreferenceSideEffects customPurposesStateChange:", e);
    }

    emitAmeConsentChanged(src, pref);
  }, _preferenceSideEffectsDelayMs);
}

/**
 * Emette evento `ameConsentChanged` su window con stato completo del consenso.
 * Pensato per consumer (incluse pagine in iframe via postMessage) che devono
 * propagare l'autorizzazione a GA4 / Google Consent Mode V2.
 *
 * Payload `event.detail`:
 *   - source, ts, consent, cmpPurposes, tcfPurposes, tcString, gdprApplies
 *   - customPurposes, consentMode (pronto per gtag consent update), derived
 *
 * Mapping Consent Mode V2 (allineato a listenTCF):
 *   analytics_storage = tcf[1] && tcf[7]
 *   ad_* = tcf[1] && (tcf[3] || tcf[4] || tcf[7])
 *
 * Oggi emesso solo da onPreferenceExpressed. Non copre forcing/migrazioni legacy.
 * @param {string} source
 * @param {object} [preference]
 */
function emitAmeConsentChanged(source, preference) {
  try {
    __tcfapi("getTCData", 2, function (tcData, success) {
      var tcf = (success && tcData && tcData.purpose && tcData.purpose.consents) || null;
      var p = tcf || {};
      var adsGranted = !!(p[1] && (p[3] || p[4] || p[7]));
      var analyticsGranted = !!(p[1] && p[7]);

      var customPurposes = null;
      try {
        customPurposes = getCustomPurposesState();
      } catch (e) { /* noop */ }

      var cmpPurposesResolved = getCurrentCmpPurposeConsents();
      if (!cmpPurposesResolved && preference && preference.purposes) {
        cmpPurposesResolved = preference.purposes;
      }

      var fullConsent = null;
      try {
        fullConsent = areConsentPurposesGranted(cmpPurposesResolved, tcf);
      } catch (e) { /* noop */ }

      var detail = {
        source: source,
        ts: Date.now(),
        consent: preference && preference.consent,
        cmpPurposes: cmpPurposesResolved,
        tcfPurposes: tcf,
        tcString: (success && tcData && tcData.tcString) || null,
        gdprApplies: (success && tcData && tcData.gdprApplies) || null,
        customPurposes: customPurposes,
        consentMode: {
          ad_storage: adsGranted ? "granted" : "denied",
          ad_user_data: adsGranted ? "granted" : "denied",
          ad_personalization: adsGranted ? "granted" : "denied",
          analytics_storage: analyticsGranted ? "granted" : "denied",
          functionality_storage: "granted",
          personalization_storage: adsGranted ? "granted" : "denied",
          security_storage: "granted"
        },
        derived: {
          ga4Granted: analyticsGranted,
          adsGranted: adsGranted,
          fullConsent: fullConsent
        }
      };

      cmpDebug("EVENTO EMESSO: ameConsentChanged", source, detail);
      try {
        window.dispatchEvent(new CustomEvent("ameConsentChanged", { detail: detail }));
      } catch (e) {
        cmpDebug("emitAmeConsentChanged dispatchEvent:", e);
      }
    });
  } catch (e) {
    cmpDebug("emitAmeConsentChanged:", e);
  }
}

/**
 * Alias pubblico per getAdditionalPurposesState. Esposto su window per uso esterno.
 * @returns {{sdkvideonielsen: boolean, sdkvideoauditel: boolean, sdktesto: boolean, pairingping: boolean, rilevazionevolumetrica: boolean}}
 */
function getCustomPurposesState() {
  return getAdditionalPurposesState();
}

window.getCustomPurposesState = getCustomPurposesState;

/** Purpose CMP richiesti per gli eventi (esclusi additionalPurposes) */
function getRequiredCmpPurposesForEvents() {
  var csConfiguration = window._iub && window._iub.csConfiguration;
  if (!csConfiguration || typeof csConfiguration !== "object") {
    return [];
  }

  var cmpPurposes = [];
  if (typeof csConfiguration.purposes === "string") {
    cmpPurposes = csConfiguration.purposes
      .split(",")
      .map(function (id) { return parseInt(String(id).trim(), 10); })
      .filter(function (id) { return Number.isFinite(id); });
  }

  return cmpPurposes;
}

/** Purpose TCF richiesti per gli eventi */
function getRequiredTcfPurposesForEvents() {
  var csConfiguration = window._iub && window._iub.csConfiguration;
  if (!csConfiguration || typeof csConfiguration !== "object") {
    return [];
  }

  var tcfPurposes = [];
  if (csConfiguration.tcfPurposes && typeof csConfiguration.tcfPurposes === "object") {
    tcfPurposes = Object.keys(csConfiguration.tcfPurposes)
      .map(function (id) { return parseInt(id, 10); })
      .filter(function (id) { return Number.isFinite(id); });
  }

  return tcfPurposes;
}

function areCmpPurposesGranted(cmpPurposeConsents) {
  if (!cmpPurposeConsents || typeof cmpPurposeConsents !== "object") {
    return false;
  }

  var requiredCmpPurposes = getRequiredCmpPurposesForEvents();
  if (!requiredCmpPurposes.length) {
    return false;
  }

  for (let i = 0; i < requiredCmpPurposes.length; i++) {
    if (cmpPurposeConsents[String(requiredCmpPurposes[i])] !== true) {
      return false;
    }
  }

  return true;
}

function areTcfPurposesGranted(tcfPurposeConsents) {
  if (!tcfPurposeConsents || typeof tcfPurposeConsents !== "object") {
    return false;
  }

  var requiredTcfPurposes = getRequiredTcfPurposesForEvents();
  if (!requiredTcfPurposes.length) {
    return false;
  }

  for (let i = 0; i < requiredTcfPurposes.length; i++) {
    if (tcfPurposeConsents[String(requiredTcfPurposes[i])] !== true) {
      return false;
    }
  }

  return true;
}

function areConsentPurposesGranted(cmpPurposeConsents, tcfPurposeConsents) {
  // Per tcf2Ready/consentRejected servono entrambi i livelli:
  // 1) purpose CMP configurati in csConfiguration.purposes
  // 2) purpose TCF configurati in csConfiguration.tcfPurposes
  // Gli additionalPurposes non rientrano in questa validazione.
  return areCmpPurposesGranted(cmpPurposeConsents) && areTcfPurposesGranted(tcfPurposeConsents);
}

function getCurrentCmpPurposeConsents() {
  try {
    if (window._iub && window._iub.cs && window._iub.cs.api && typeof window._iub.cs.api.getPreferences === "function") {
      var prefs = window._iub.cs.api.getPreferences();
      if (prefs && prefs.purposes && typeof prefs.purposes === "object") {
        return prefs.purposes;
      }
    }
  } catch (e) {}

  return null;
}

var _lastEmittedConsentEventState = null;

function emitConsentStateEvent(state, debugMessage) {
  if (_lastEmittedConsentEventState === state) {
    cmpDebug("emitConsentStateEvent - skip duplicato:", state);
    return false;
  }

  _lastEmittedConsentEventState = state;

  var eventName = state === "ready" ? "tcf2Ready" : "consentRejected";
  window.dispatchEvent(new Event(eventName));
  cmpDebug(debugMessage);

  window.pageTimings = window.pageTimings || {};
  if (state === "ready") {
    window.pageTimings.tcfIsReady = performance.now();
  } else {
    window.pageTimings.consentRejected = performance.now();
  }

  return true;
}

var isEnglishCookiePolicy =
  ameCp.lang === "en" ||
  (typeof ameCp.text === "string" &&
    /selected\s+(?:\d+|%\{total_number_of_ads_vendors\})\s+third parties/i.test(ameCp.text));

var _iub = _iub || [];
_iub.csConfiguration = {
  cookiePolicyId: ameCp.cookiePolicyIdValue,
  siteId: ameCp.siteIdValue,
  cookiePolicyUrl: ameCp.cookiePolicyUrl,
  localConsentDomain: ameCp.localConsentDomain,
  lang: ameCp.lang,
  consentOnScroll: false,
  consentOnScrollHorizontal: false,
  consentOnContinuedBrowsing: false,
  enableTcf: true,
  tcfVersion: 2.3,
  invalidateConsentBefore: "2024-01-08",
  googleAdditionalConsentMode: true,
  isTCFConsentGlobal: false,
  askConsentAtCookiePolicyUpdate: false,
  perPurposeConsent: true,
  tcfPurposes: {
    1: "consent_only",
    2: "consent_only",
    3: "consent_only",
    4: "consent_only",
    5: "consent_only",
    6: "consent_only",
    7: "consent_only",
    8: "consent_only",
    9: "consent_only",
    10: "consent_only",
    11: "consent_only",
  },
  "purposes": "1,2,3,4,5",
  listPurposes: true,
  additionalPurposes: isEnglishCookiePolicy ? [] : [
    {
      "id": "sdkvideonielsen",
      "defaultLabel": "SDK Video Nielsen",
      "defaultDescription": "Permette ad Audicom S.r.l. (titolare del trattamento), salvo opposizione (opt-out), di analizzare la fruizione dei contenuti video a fini di rilevazione audience (i.e. per analisi e statistiche anonime e aggregate sui contenuti fruiti dagli utenti e sui volumi di consumo dei medesimi contenuti). Previo consenso, Audicom utilizzerà maggiori informazioni per una rilevazione audience più precisa.",
      "value": false,
      "readonly": false
  },
  {
    "id": "sdkvideoauditel",
    "defaultLabel": "SDK Video",
    "defaultDescription": "Permette ad Audicom S.r.l. (titolare del trattamento), salvo opposizione (opt-out), di analizzare la fruizione dei contenuti video a fini di rilevazione audience (i.e. per analisi e statistiche anonime e aggregate sui contenuti fruiti dagli utenti e sui volumi di consumo dei medesimi contenuti). Previo consenso, Audicom utilizzerà maggiori informazioni per una rilevazione audience più precisa. Al momento, la rilevazione audience Audicom sulla base di tale strumento è in fase di sviluppo e le analisi e statistiche anonime e aggregate derivanti dai dati raccolti tramite SDK Video non saranno distribuite.",
    "value": false,
    "readonly": false
},
  {
      "id": "sdktesto",
      "defaultLabel": "SDK Testo",
      "defaultDescription": "Permette ad Audicom S.r.l. (titolare del trattamento), salvo opposizione (opt-out), di analizzare la fruizione dei contenuti testuali a fini di rilevazione audience (i.e. per analisi e statistiche anonime e aggregate sui contenuti fruiti dagli utenti e sui volumi di consumo dei medesimi contenuti). Previo consenso, Audicom utilizzerà maggiori informazioni per una rilevazione audience più precisa.",
      "value": false,
      "readonly": false
  },
    {
        "id": "pairingping",
        "defaultLabel": "Pairing Ping",
        "defaultDescription": "Permette ad Audicom S.r.l. (titolare del trattamento), previo consenso, di rilevare l’informazione relativa alla presenza, sul dispositivo dell’utente, di determinati cookie già precedentemente installati (i.e. cookie di terza parte denominati IMRID). Tale informazione consente una rilevazione audience più precisa della fruizione dei contenuti video. Al momento, la rilevazione audience Audicom sulla base di tale strumento è in fase di sviluppo e le analisi e statistiche anonime e aggregate derivanti dai dati raccolti tramite Pairing Ping non saranno distribuite.",
        "value": false,
        "readonly": false
    },
    {
        "id": "rilevazionevolumetrica",
        "defaultLabel": "Opposizione (opt-out) alla rilevazione audience Audicom",
        "defaultDescription": "Deselezionare la casella per non contribuire alla rilevazione audience di Audicom S.r.l.",
        "value": true,
        "readonly": false
    }
  ],
  banner: {
    prependOnBody: false,
    applyStyles: false,
    content: ameCp.text,
    html: ameCp.html,
    closeButtonDisplay: false,
    showPurposesToggles: true,
    listPurposes: true,
  },
  callback: {
    onReady : async function() {
        cmpDebug("onReady - CMP ready, inizializzazione");
        if (_hadLegacyNonPurposeCookieOnLoad) {
          migrateLegacyFullConsent();
        } else {
          normalizeLegacyConsentGivenRilevazioneVolumetrica();
        }
        /* --- BEGIN DAF-406 --- */
        emitEsitoNormalizzazioneVolumetrica();
        /* --- END DAF-406 --- */
        if(window.googleConsentModeV2) {
          (function listenTCF(){
            var cb = function(tcData, success){
              if(!success) return;

              var p = tcData.purpose && tcData.purpose.consents || {};
              var adsGranted = !!(p[1] && (p[3] || p[4] || p[7]));
              var analyticsGranted = !!(p[1] && p[7]);
              cmpDebug("Google Consent Mode V2 - Valori calcolati", {
                eventStatus: tcData && tcData.eventStatus,
                purpose1: !!p[1],
                purpose3: !!p[3],
                purpose4: !!p[4],
                purpose7: !!p[7],
                adsGranted: adsGranted,
                analyticsGranted: analyticsGranted
              });

              gtag('consent', 'update', {
                ad_storage: adsGranted ? 'granted' : 'denied',
                ad_user_data: adsGranted ? 'granted' : 'denied',
                ad_personalization: adsGranted ? 'granted' : 'denied',
                analytics_storage: analyticsGranted ? 'granted' : 'denied'
              });
              cmpDebug("Google Consent Mode V2 - Aggiorna i consensi Google", {
                ad_storage: adsGranted ? 'granted' : 'denied',
                ad_user_data: adsGranted ? 'granted' : 'denied',
                ad_personalization: adsGranted ? 'granted' : 'denied',
                analytics_storage: analyticsGranted ? 'granted' : 'denied'
              });
            };

            cmpDebug("Google Consent Mode V2 - Aggiungi listener per aggiornare i consensi Google")
            __tcfapi("ping", 2, function (pingData) {
              window.__tcfapi('addEventListener', 2, cb);
            });

          })();
        }
    },
    onBannerShown: async function () {
      await yieldToMainNC();
      applyIubVendorCountShortcodeFallback();
      document.body.classList.add("cp-banner-visible");
      cmpDebug("onBannerShown - Banner cookie policy visualizzato");
      setupPanelOpenedDetection();
      cmpLogV2.emit("banner_shown", "Banner_Mostrato");
    },
    onBannerClosed: async function () {
      await yieldToMainNC();
      document.body.classList.remove("cp-banner-visible");
      cmpDebug("onBannerClosed - Banner cookie policy chiuso");
    },
    onPreferenceFirstExpressed: async function (preference) {
      await yieldToMainNC();
      cmpDebug("onPreferenceFirstExpressed - Consenso:", preference.consent);
    },
    onPreferenceExpressed: async function (preference) {
      await yieldToMainNC();
      cmpDebug("[rilevazionevolumetrica] onPreferenceExpressed - INIZIO - _panelWasOpened:", _panelWasOpened, "_rejectedFromPanel:", _rejectedFromPanel, "preference.consent:", preference.consent);
      var oldRejectedFromPanel = _rejectedFromPanel;
      if (_panelWasOpened) {
        _rejectedFromPanel = true;
        cmpDebug("[rilevazionevolumetrica] onPreferenceExpressed - pannello aperto (_panelWasOpened=true), imposto _rejectedFromPanel da", oldRejectedFromPanel, "a", _rejectedFromPanel, "preference.purposes:", preference.purposes);
      } else {
        _rejectedFromPanel = false;
        cmpDebug("[rilevazionevolumetrica] onPreferenceExpressed - banner principale (_panelWasOpened=false), imposto _rejectedFromPanel da", oldRejectedFromPanel, "a", _rejectedFromPanel, "preference.purposes:", preference.purposes);
      }
      cmpDebug("[rilevazionevolumetrica] onPreferenceExpressed - FINE - _panelWasOpened:", _panelWasOpened, "_rejectedFromPanel:", _rejectedFromPanel);
      if (preference.purposes && window._iub && window._iub.cs) {
        setTimeout(function () {
          try {
            if (window._iub.cs.savePreferences) {
              window._iub.cs.savePreferences();
              cmpDebug("Preferenze salvate forzatamente (workaround perPurposeConsent)");
            }
          } catch (e) {
            cmpDebug("Impossibile forzare il salvataggio:", e);
          }
        }, 100);
      }
      let isPurposeBased = false;
      let hasFalsePurpose = false;

      if (preference.purposes && typeof preference.purposes === 'object') {
        isPurposeBased = true;
        // Qui validiamo solo i purpose CMP (1..5 da config), non gli additionalPurposes.
        hasFalsePurpose = !areCmpPurposesGranted(preference.purposes);
      }

      cmpDebug("onPreferenceExpressed - Tipo CMP:", isPurposeBased ? "purpose-based" : "non purpose-based");

      // In modalita perPurposeConsent la decisione dipende dalla mappa purpose, non da preference.consent.
      const consentIsFalse = isPurposeBased ? hasFalsePurpose : (preference.consent == false);

      if (consentIsFalse) {
        window.ameConsentGiven = false;
        emitConsentStateEvent(
          "rejected",
          "onPreferenceExpressed - EVENTO EMESSO: consentRejected " +
            (isPurposeBased ? "(purpose-based: almeno un purpose false)" : "(consenso rifiutato)")
        );
        cmpLogV2.emit("consent_rejected", "Consenso_Negato");
      }

      const canEvaluateFullConsent = isPurposeBased ? !hasFalsePurpose : (preference.consent == true && !hasFalsePurpose);
      if (canEvaluateFullConsent) {
        if (typeof postFirstConsentGivenCB === "function") {
          postFirstConsentGivenCB();
        }

        if (typeof window.consentGivenInSession === "undefined") {
          __tcfapi("ping", 2, function (pingData) {
            __tcfapi("getTCData", 2, function (tcData, success) {
              if (success && tcData && tcData.eventStatus != "cmpuishown") {
                const purposes = tcData.purpose && tcData.purpose.consents || {};
                // Validazione pieno consenso: CMP purposes + TCF purposes.
                const allPurposesGranted = areConsentPurposesGranted(preference.purposes, purposes);

                if (allPurposesGranted) {
                  window.consentGivenInSession = 1;
                  window.tcfIsReady = 1;

                  emitConsentStateEvent(
                    "ready",
                    "onPreferenceExpressed - EVENTO EMESSO: tcf2Ready - pieno consenso (tutti i purpose necessari sono true)"
                  );
                  cmpLogV2.emit("consent_granted", "Consenso_Dato");

                  if (typeof GTMConsent === "function") {
                    GTMConsent();
                  }
                } else {
                  window.ameConsentGiven = false;
                  emitConsentStateEvent(
                    "rejected",
                    "onPreferenceExpressed - EVENTO EMESSO: consentRejected (consenso parziale - non tutti i purpose necessari sono true)"
                  );
                  cmpLogV2.emit("consent_rejected", "Consenso_Negato");
                }
              }
            });
          });
        }
      }
      if (typeof window.permutive === "object") {
        __tcfapi("getTCData", 2, (tcData, success) => {
          if (success && tcData) {
            if (
              tcData.purpose.consents["1"] &&
              tcData.purpose.consents["3"] &&
              tcData.purpose.consents["5"] &&
              tcData.purpose.consents["7"] &&
              tcData.purpose.consents["9"] &&
              tcData.vendor.consents["361"]
            ) {
              if (!window.permutiveEnabled) {
                window.permutiveEnabled = true;
                window.permutive.consent({
                  opt_in: true,
                  token: tcData.tcString,
                });
                cmpDebug("permutive - setup consent with token", tcData.tcString);
              }
            } else {
              window.permutiveEnabled = false;
              window.permutive.consent({ opt_in: false });
              cmpDebug("permutive - opt-out");
            }
          }
        });
      }
      cmpDebug("onPreferenceExpressed - completato", preference);
      schedulePreferenceSideEffects("onPreferenceExpressed", preference);
    },

    onConsentGiven: async function () {
      await yieldToMainNC();
      __tcfapi("ping", 2, function (pingData) {
        __tcfapi("getTCData", 2, function (tcData, success) {
          if (typeof window.consentGivenInSession === "undefined") {
            window.consentGivenInSession = 1;
            cmpDebug("onConsentGiven - TCF data ricevuto:", tcData, "success:", success);
            if (success && tcData && tcData.eventStatus != "cmpuishown") {
              const purposes = tcData.purpose && tcData.purpose.consents || {};
              const cmpPurposes = getCurrentCmpPurposeConsents();
              // Anche in onConsentGiven tcf2Ready parte solo se CMP+TCF sono entrambi completamente granted.
              const allPurposesGranted = areConsentPurposesGranted(cmpPurposes, purposes);

              if (allPurposesGranted) {
                cmpDebug("onConsentGiven - Verifica purpose: tutti i purpose necessari sono true");
                window.tcfIsReady = 1;

                emitConsentStateEvent(
                  "ready",
                  "onConsentGiven - EVENTO EMESSO: tcf2Ready - pieno consenso (tutti i purpose necessari sono true)"
                );
                cmpLogV2.emit("consent_granted", "Consenso_Dato");

                if (typeof GTMConsent === "function") {
                  GTMConsent();
                }
              } else {
                cmpDebug("onConsentGiven - Verifica purpose: consenso parziale o rifiutato (non tutti i purpose necessari sono true)");
                window.ameConsentGiven = false;
                emitConsentStateEvent(
                  "rejected",
                  "onConsentGiven - EVENTO EMESSO: consentRejected (consenso parziale o rifiutato)"
                );
                cmpLogV2.emit("consent_rejected", "Consenso_Negato");
              }
            }
          }
        });
      });
    },
    onConsentRejected: async function () {
      await yieldToMainNC();
      var canForce = !_hadConsentCookieOnLoad && !_panelWasOpened && !_rejectedFromPanel;
      cmpDebug("[rilevazionevolumetrica] ⚠️ onConsentRejected - INIZIO - flags:", {
        _hadConsentCookieOnLoad: _hadConsentCookieOnLoad,
        _panelWasOpened: _panelWasOpened,
        _rejectedFromPanel: _rejectedFromPanel,
        canForce: canForce
      });
      if (canForce) {
        cmpDebug("[rilevazionevolumetrica] ✅ FORZO rilevazionevolumetrica=true (virgin reject da banner) - _panelWasOpened:", _panelWasOpened, "_rejectedFromPanel:", _rejectedFromPanel);
        forceRilevazioneVolumetricaTrueViaApi();
      } else {
        var motivo = _hadConsentCookieOnLoad ? "cookie preesistente" : _panelWasOpened ? "pannello aperto (_panelWasOpened=true)" : "salvataggio da pannello (_rejectedFromPanel=true)";
        cmpDebug("[rilevazionevolumetrica] ❌ NON forzo - motivo:", motivo, "- _panelWasOpened:", _panelWasOpened, "_rejectedFromPanel:", _rejectedFromPanel);
      }
      var oldRejectedFromPanelEnd = _rejectedFromPanel;
      _rejectedFromPanel = false;
      cmpDebug("[rilevazionevolumetrica] onConsentRejected - FINE - resetto _rejectedFromPanel da", oldRejectedFromPanelEnd, "a", _rejectedFromPanel);
    },
    on2ndLayerShown: async function () {
      await yieldToMainNC();
      var oldValue = _panelWasOpened;
      _panelWasOpened = true;
      cmpDebug("[rilevazionevolumetrica] ⚠️ on2ndLayerShown - _panelWasOpened cambiato da", oldValue, "a", _panelWasOpened);
      setupRilevazioneVolumetricaCascade();
      setupBackButtonDetection();
    },
  },
};

let stubSrc = "https://cdn.iubenda.com/cs/tcf/stable/stub-v2.js";
let iubendaCsSrc = "https://cdn.iubenda.com/cs/stable/iubenda_cs.js";


(async function (w, d) {
  var s = d.createElement("script"),
    tag = d.head;
  s.async = true;
  s.src = stubSrc;
  await yieldToMainNC();
  tag.appendChild(s);

  s.onload = addIubendaCs(window, document);
})(window, document);

async function addIubendaCs(w, d) {
  var s = d.createElement("script"),
    tag = d.head;
  s.async = true;
  s.src = iubendaCsSrc;
  await yieldToMainNC();
  tag.appendChild(s);
}

/**
 * @avInline {}
 */

/*
 * Iubenda is often the cause of an high INP.
 * That's because the code that creates the TCF string isn't optimized and
 * Iubenda does a poor job to try scheduling that to minimize the inpact on
 * INP.
 *
 * They try to move the long task where the TCF string is built by using
 * `setTimeout(process, 0)` in the `click` event listener but this isn't always
 * effective. Chrome for example might schidule the timer task right away after
 * the listener, defeating its purpose.
 *
 * To avoid that here we try to intercept the `click` event, block its
 * propagation and schedule a synthetic click in a `requestAnimationFrame`
 * callback. This way the Iubenda listener will schedule a timer inside a
 * `requestAnimationFrame` task, making Chrome execute the timer only after
 * rendering and painting.
 *
 * This is just a workaround from our side, they should really fix their code
 * and avoid blocking the main thread for that long.
 */

// eslint-disable-next-line no-underscore-dangle

const csConfig = self._iub.csConfiguration;
const oldOnReady = csConfig.callback.onReady;

csConfig.callback.onReady = function() {
	/*
	 * Iubenda calls the `onReady` callback synchronously just after the
	 * banner setup.
	 *
	 * If we don't find the banner element here it's because Iubenda isn't
	 * showing it (i.e. the visitor already expressed their preferences
	 * before).
	 */
	const iubendaBannerContainer = document.getElementById("iubenda-cs-banner");
	if (iubendaBannerContainer) {
		self.addEventListener("click", onClickIubenda, {capture: true});
	}

	if (oldOnReady) {
		oldOnReady();
	}
};

function onClickIubenda(event) {
	const IUBENDA_BUTTON_CLASSES = [
		// The "accept" button in the initial layer
		"iubenda-cs-accept-btn",

		// The "reject" button in the initial layer
		"iubenda-cs-reject-btn",
	];

	const IUBENDA_SAVE_BUTTON_ID = "iubFooterBtn";

	const {target} = event;

	if (!(
		IUBENDA_BUTTON_CLASSES.some(_ => target.classList.contains(_)) ||
		target.id === IUBENDA_SAVE_BUTTON_ID
	)) {
		return;
	}

	self.removeEventListener("click", onClickIubenda, {capture: true});

	event.stopImmediatePropagation();

  cmpDebug("DAF-322 Pro INP");

	const raf = self.requestAnimationFrame.bind(self);
	const rafAndTimer = callback => raf(() => setTimeout(callback));

	/*
	 * The `click` listener of `#iubFooterBtn` doesn't use
	 * `setTimeout` as the other buttons, let's add it by
	 * ourselves.
	 */
	const runAfterNextPaint = target.id === IUBENDA_SAVE_BUTTON_ID ?
		rafAndTimer :
		raf;

	runAfterNextPaint(() => target.click());
}


(async function () {
  let script = document.createElement("script");
  script.async = true;
  script.src =
    "https://dafne.sirio.stbm.it/utility-fe/prod/general/permutive/permutiveIdGenerator.js";
  await yieldToMainNC();
  document.body.appendChild(script);

  script.onload = () => {
    window.permutiveIdGeneratorReady = true;
    var permutiveIdGeneratorReady = new Event("permutiveIdGeneratorReady");
    window.dispatchEvent(permutiveIdGeneratorReady);
  };
})();

var AME2MMConsent = 0;

function postFirstConsentGivenCB() {
  var postFirstConsentGivenEvent = new Event("postFirstConsentGivenEvent");
  window.dispatchEvent(postFirstConsentGivenEvent);
  if (typeof initGptCMP === "function") {
    initGptCMP(AME2MMConsent);
  }
}

window.addEventListener(
  "MMAdvCall",
  function (e) {
    // console.debug('consenso dato, posso erogare');
    if (typeof initGptCMP === "function") {
      initGptCMP(AME2MMConsent);
    }
  },
  false
);

var AMENetworkCommon = new Event("AMENetworkCommon");
window.dispatchEvent(AMENetworkCommon);

var _panelOpenedDetectionSetup = false;

/**
 * Registra un listener per rilevare il click su "Opzioni cookie" **nel banner**
 * (`#iubenda-cs-banner` / `#ameConsentUI`), non dal footer. Imposta `_panelWasOpened=true`
 * così `onConsentRejected` non forza rilevazione volumetrica; emette `cmp_log_v2` Opzioni_Aperte.
 * Chiamato da `onBannerShown`. Solo la prima esecuzione registra il listener.
 */
function setupPanelOpenedDetection() {
  if (_panelOpenedDetectionSetup) return;
  _panelOpenedDetectionSetup = true;
  cmpDebug("[rilevazionevolumetrica] setupPanelOpenedDetection - listener registrato, _panelWasOpened corrente:", _panelWasOpened);
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t) return;
    var inBanner = t.closest && t.closest("#iubenda-cs-banner, #ameConsentUI");
    var triggerEl =
      inBanner &&
      (t.closest(".amecp_button-customize") || t.closest(".iubenda-cs-preferences-link"));
    if (!triggerEl) return;
    var oldValue = _panelWasOpened;
    _panelWasOpened = true;
    cmpDebug("[rilevazionevolumetrica] ⚠️ CLICK SU OPZIONI COOKIE (banner) - _panelWasOpened cambiato da", oldValue, "a", _panelWasOpened);
    cmpLogV2.emit("options_opened", "Opzioni_Aperte");
  }, true);
}

// fix Safari
(function () {
  let isIOS = function () {
    return [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform);
  };

  let isSafari = function () {
    const agent = navigator.userAgent;
    const platformExpression = /Mac|iPhone|iPod|iPad/i;
    const rejectedExpression = /Chrome|Android|CriOS|FxiOS|EdgiOS/i;
    const expectedExpression = /Safari/i;

    if (rejectedExpression.test(agent)) {
      return false;
    }
    return platformExpression.test(agent) && expectedExpression.test(agent);
  };

  setTimeout(() => {
    if (isSafari() && !isIOS() && "loading" in HTMLImageElement.prototype) {
      console.log("fix safari images");
      const nodes = document.querySelectorAll("img[loading]");
      nodes.forEach((img) => {
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    }
  }, 1000);

  setTimeout(() => {
    //DAF-271
    if (isSafari() && document.querySelector(".instagram-media")) {
      let script = document.createElement("script");
      script.src =
        "https://dafne.sirio.stbm.it/utility-fe/prod/general/instagram/embed.js";
      document.body.appendChild(script);
    }
  }, 200);
})();

/**
 * Flyingvideo vs Strip Advertisement Handler
 * 
 * This self-executing function manages the positioning of Flyingvideo
 * advertisements relative to strip advertisements on mobile devices. It 
 * specifically targets devices with screen widths of 480px or less.
 * 
 * Technical Details:
 * 1. Device Width Check:
 *    - Executes only on devices with width ≤ 480px
 *    - Returns false for larger screens
 * 
 * 2. Advertisement Detection:
 *    - Monitors Google Ad slots for two specific strip sizes:
 *      * 320x50 pixels
 *      * 320x100 pixels
 *    - Uses separate control flags (controllo50, controllo100) for each size
 * 
 * 3. Position Adjustment:
 *    - For 320x50 strips: Moves flying video up by 60px
 *    - For 320x100 strips: Moves flying video up by 125px
 *    - Adds 15px bottom margin in both cases
 * 
 * 
 * Implementation Details:
 * - Uses control flags to prevent multiple style injections
 * - Removes event listener after detecting 320x100 strip
 * - Injects styles asynchronously using yieldToMainNC
 * 
 * @returns {boolean|undefined} Returns false if screen width > 480px
 */
(() => {
  // Exit if not mobile device
  if (window.innerWidth > 480) {
      return false;
  }

  console.log('[flyingvideo vs strip detection]', 'init');

  window.googletag = window.googletag || { cmd: [] };

  // Control flags for different strip sizes
  let controllo50 = 0;
  let controllo100 = 0;

  googletag.cmd.push(() => {
      /**
       * Handles the slot loading event for push vs strip detection
       * @param {Event} event - Google Ad slot load event
       */
      const mySlotOnloadListenerPushVsStrip = (event) => {
          const slot = event.slot;
          const sizes = slot.getSizes();

          // Only process 320px width ads
          if (sizes[0].width === 320) {
              console.log('[flyingvideo vs strip detection]', 'check su slot 320');
              
              const idSlot = slot.getSlotElementId();
              const slotHeight = parseInt(document.getElementById(idSlot).offsetHeight);

              // Handle 60px (10px margin) height strip
              if (slotHeight <= 60 && controllo50 === 0) {
                  console.log('[flyingvideo vs strip detection]', 'strip detected', '50');
                  controllo50 = 1;
                  
                  injectInlineStyle(`
                      body .av-push-static.active .av-push-flying.inflight {
                          bottom: 15px;
                          transform: translateY(-60px)!important;
                      }
                  `);
              } 
              // Handle larger strips
              else if (controllo100 === 0) {
                  console.log('[flyingvideo vs strip detection]', 'strip detected', '>50');
                  controllo100 = 1;
                  
                  injectInlineStyle(`
                      body .av-push-static.active .av-push-flying.inflight {
                          bottom: 15px;
                          transform: translateY(-125px)!important;
                      }
                  `);

                  // Cleanup: remove listener after detecting larger strip
                  googletag.pubads().removeEventListener("slotOnload", mySlotOnloadListenerPushVsStrip);
                  console.log('[flyingvideo vs strip detection]', 'remove listener');
              }
          }
      };

      // Add event listener for slot loading
      googletag.pubads().addEventListener("slotOnload", mySlotOnloadListenerPushVsStrip);
  });

  /**
   * Injects CSS rules into the document head asynchronously
   * @param {string} cssRules - CSS rules to be injected
   * @returns {Promise<void>}
   */
  async function injectInlineStyle(cssRules) {
      // Create style element
      const styleElement = document.createElement('style');
      styleElement.type = 'text/css';
      
      // Add CSS rules
      styleElement.appendChild(
          document.createTextNode(cssRules)
      );

      // Wait for main thread
      await yieldToMainNC();
      
      // Inject styles
      document.head.appendChild(styleElement);
  }
})();